import script from "./SongCommentsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./SongCommentsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./SongCommentsSidebar.vue?vue&type=style&index=0&id=67115e27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67115e27"]])

export default __exports__